import { __extends } from "tslib";
import { NativeMenuItem } from '../display/NativeMenuItem';
import { axCoerceString } from '@awayfl/avm2';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: ContextMenuItem
var ContextMenuItem = /** @class */ (function (_super) {
    __extends(ContextMenuItem, _super);
    function ContextMenuItem(caption, separatorBefore, enabled, visible) {
        if (separatorBefore === void 0) { separatorBefore = false; }
        if (enabled === void 0) { enabled = true; }
        if (visible === void 0) { visible = true; }
        var _this = _super.call(this) || this;
        caption = axCoerceString(caption);
        separatorBefore = !!separatorBefore;
        enabled = !!enabled;
        visible = !!visible;
        _this._caption = caption ? caption : '';
        _this._separatorBefore = separatorBefore;
        _this._enabled = enabled;
        _this._visible = visible;
        return _this;
    }
    Object.defineProperty(ContextMenuItem.prototype, "caption", {
        get: function () {
            return this._caption;
        },
        set: function (value) {
            value = axCoerceString(value);
            this._caption = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenuItem.prototype, "separatorBefore", {
        get: function () {
            return this._separatorBefore;
        },
        set: function (value) {
            value = !!value;
            this._separatorBefore = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContextMenuItem.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        set: function (value) {
            value = !!value;
            this._visible = value;
        },
        enumerable: true,
        configurable: true
    });
    // Called whenever the class is initialized.
    ContextMenuItem.classInitializer = null;
    // List of static symbols to link.
    ContextMenuItem.classSymbols = null; // [];
    // List of instance symbols to link.
    ContextMenuItem.instanceSymbols = null; // ["clone"];
    return ContextMenuItem;
}(NativeMenuItem));
export { ContextMenuItem };
